import React from "react";
import { instance } from "../../../config/serverConfig";

export interface ReactivationConfig {
  title: string;
  yesTitle: string;
  yesSubTitle: string;
  noTitle: string;
  noSubTitle: string;
  reactCommentTitle: JSX.Element | string;
  reactCommentPlaceholder: string;
}

interface Dict {
  [state: string]: ReactivationConfig;
}

export const reactivationRules: Dict = {
  "fixed": {
    title: "Did this solution work for you?",
    yesTitle: "Yes, it works",
    yesSubTitle: "Fixed with no extra steps",
    noTitle: "No, I tried everything",
    noSubTitle: "Please re-open this",
    reactCommentTitle: instance.isInternal ? "" : <div>I have installed the fix by upgrading to the <a href='https://visualstudio.com' target='_blank' rel="noopener noreferrer">latest version of Visual Studio</a>.The issue is still not fixed: </div>,
    reactCommentPlaceholder: "Here is what I tried and what happened.",
  },
  "lowerpriority": {
    title: "Does this correctly reflect the severity of the issue?",
    yesTitle: "Yes, I agree",
    yesSubTitle: "This is low impact for me",
    noTitle: "No",
    noSubTitle: "This is blocking my work",
    reactCommentTitle: "This is impacting me because:",
    reactCommentPlaceholder: "Explain why this is impactful. Examples: blocking, used to work, no workaround, happens frequently",
  },
  "notabug": {
    title: "If you feel we need to re-evaluate the outcome, you can let us know why by selecting ‘Reconsider’ below.",
    yesTitle: "OK, good to know",
    yesSubTitle: "",
    noTitle: "Reconsider",
    noSubTitle: "",
    reactCommentTitle: "I believe this issue should be reconsidered because:",
    reactCommentPlaceholder: "Provide any additional new information about the issue that will help with re-evaluation.",
  },
  "notenoughinfo": {
    title: "If you have the additional information and feel we need to re-evaluate the outcome, you can let us know by selecting ‘Reconsider’ below.",
    yesTitle: "OK",
    yesSubTitle: "Good to know",
    noTitle: "Reconsider",
    noSubTitle: "I have additional info",
    reactCommentTitle: "I believe this issue should be reconsidered because:",
    reactCommentPlaceholder: "Include additional details and any attachments that will help with the re-evaluation.",
  },
  "duplicate": {
    title: "Is this the same issue?",
    yesTitle: "Yes",
    yesSubTitle: "",
    noTitle: "No",
    noSubTitle: "They are different",
    reactCommentTitle: "I believe the two reports are different",
    reactCommentPlaceholder: "Here is why they are different",
  },
  "otherproduct": {
    title: "Is this an issue with a different product?",
    yesTitle: "Yes, I agree",
    yesSubTitle: "",
    noTitle: "No",
    noSubTitle: "It's this product",
    reactCommentTitle: "Here is why it applies to this product:",
    reactCommentPlaceholder: "Please share as much information as possible",
  },
}